import { Helmet } from "react-helmet-async";
import { createElement, type ReactElement } from "react";

/**
 * useSEO — returns a <Helmet> element with standardized SEO tags.
 * Usage: const seo = useSEO(title, description, canonical); return <>{seo}...</>;
 */
export function useSEO(
  title: string,
  description: string,
  canonical: string,
): ReactElement {
  const fullTitle = `${title} | ClearSlot`;
  return createElement(
    Helmet,
    null,
    createElement("title", null, fullTitle),
    createElement("meta", { name: "description", content: description }),
    createElement("link", { rel: "canonical", href: canonical }),
    createElement("meta", { property: "og:title", content: fullTitle }),
    createElement("meta", { property: "og:description", content: description }),
    createElement("meta", { property: "og:url", content: canonical }),
  );
}
